<button [matMenuTriggerFor]="notificationsMenu"
        [matTooltip]="title"
        mat-icon-button
        type="button"
        data-cy="alerts-menu-trigger">
    <div class="notification-count">
        <mat-icon>notifications</mat-icon>
        <div *ngIf="hasNotifications$ | async"
             class="notification-bubble"></div>
    </div>
</button>
<mat-menu #notificationsMenu="matMenu"
          [overlapTrigger]="false"
          class="alerts-dropdown">
    <div *ngIf="alertMenuTrigger.menuOpen"
         [cdkTrapFocus]="alertMenuTrigger.menuOpen"
         (keydown.tab)="$event.stopPropagation()"
         (keydown.shift.tab)="$event.stopPropagation()">
        <div #menuSubhead
             cdkFocusRegionStart
             class="mat-subhead"
             tabindex="0">
            <span [matTooltip]="title">{{title}}</span>
            <button [matTooltip]="settingsTooltip"
                    (click)="openSettings.emit()"
                    mat-icon-button
                    type="button"
                    class="notification-settings">
                <mat-icon>settings</mat-icon>
            </button>
        </div>
        <mat-divider></mat-divider>

        <mat-nav-list dense
                      class="alerts-container">
            <div *ngIf="loading$ | async">
                <mat-progress-spinner class="alert-loadingstate"
                                      mode="indeterminate"
                                      color="accent"
                                      [diameter]="20"
                                      [strokeWidth]="2">
                </mat-progress-spinner>
            </div>
            <ng-container *ngIf="alerts$ | async as alerts">
                <div *ngIf="!(loading$ | async) && alerts.length === 0"
                     translate
                     class="alert-blankstate">
                    {{noAlertsPlaceholder}}
                </div>
                <ng-template [ngForOf]="alerts"
                             ngFor
                             let-alert
                             let-last="last">
                    <a [routerLink]="['/alerts']"
                       tabindex="0"
                       mat-list-item>
                        <ng-container [ngSwitch]="alert.component">
                            <mat-icon *ngSwitchCase="'Robots'"
                                      mat-list-avatar
                                      svgIcon="uipath:robots">
                            </mat-icon>
                            <mat-icon *ngSwitchCase="'Transactions'"
                                      mat-list-avatar
                                      svgIcon="uipath:queues">
                            </mat-icon>
                            <mat-icon *ngSwitchCase="'Triggers'"
                                      mat-list-avatar
                                      svgIcon="uipath:triggers">
                            </mat-icon>
                            <mat-icon *ngSwitchCase="'Jobs'"
                                      mat-list-avatar
                                      svgIcon="uipath:jobs">
                            </mat-icon>
                            <mat-icon *ngSwitchCase="'Process'"
                                      mat-list-avatar>swap_horiz</mat-icon>
                            <mat-icon *ngSwitchCase="'Queues'"
                                      mat-list-avatar
                                      svgIcon="uipath:queues">
                            </mat-icon>
                        </ng-container>
                        <div class="mat-list-text">
                            <h4 [matTooltip]="alert.data.message"
                                matLine>
                                <span class="text-wrap">
                                    {{alert.data.message}}
                                </span>
                            </h4>
                            <p matLine>
                                <ui-dateformat #timeStampFormat
                                               [matTooltip]="timeStampFormat?.dataset['title']"
                                               [date]="alert.timestamp"
                                               contentType="relative"></ui-dateformat>
                            </p>
                        </div>
                    </a>
                    <mat-divider *ngIf="!last"
                                 aria-hidden="true"></mat-divider>
                </ng-template>
            </ng-container>
        </mat-nav-list>
        <mat-divider></mat-divider>
        <a [routerLink]="['/alerts']"
           cdkFocusRegionEnd
           mat-button
           tabindex="0"
           color="accent"
           class="alerts-footer"
           data-cy="alerts-page-router">
            {{ seeAllPlaceholder }}
        </a>

    </div>
</mat-menu>
